module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/venue_yokohama-36515070a965ecc57122f79e5702d035.jpg";